var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-button',{on:{"click":_vm.handleShare}},[_vm._v("分享商品")]),_vm._v(" 公司信息："+_vm._s(_vm.companyInfo.id)+" 用户信息："+_vm._s(_vm.userInfo.nikename)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }